// Ready translated locale messages
const translation = {
    EN: {
        title: {
            rowsPerPage: 'Rows per page:',
            searchForParcel: "Search for parcel",
            searchForParcelOrGeographicName: "Search for parcel or geographic name",
            chooseLocation: "Choose location",
            searchExample: "E.g. 123/1 or geographic name",
            note: 'Note',
            label: 'Label',
            category: 'Category',
            legend: 'Legend',
            userSetting: 'User settings',
            logout: 'Log out',
            noteFilter: 'Note filters',
            imagePreview: 'Image preview',
            transparency: 'Transparency',
            swipe: 'Swipe',
            realEstates: 'Real estates',
            remoteSensing: 'Remote sensing',
            delivery: 'Delivery',
            ordering: 'Ordering',
            orderingSatellite: 'Ordering satellite',
            satelliteChanges: 'Satellite changes',
            hidePanel: 'Hide panel',
            manualMeasurement: 'Manual Measurement',
            measureLine: 'Measure line',
            searchByPolygon: 'Search by polygon',
            searchByRectangle: 'Search by rectangle',
            measureArea: 'Measure area',
            measureCircle: 'Measure circle',
            removeCurrentMeasurements: 'Remove current measurements',
            measurement: "Measurement",
            clearMeasurements: "Clear measurements",
            storaensoLogo: "StoraEnso logo",
            layerSwitcher: "Layer switcher",
            layers: "Layers",
            userNotes: "User notes",
            forestCompartment: "Forest Compartment",
            changeDetection: "Change detection",
            analysis: "Analysis",
            droneMissions: "Drone missions",
            falseColorBands: "False color bands",
            collapsePanel: "Collapse panel",
            hideTab: "Hide tab",
            hide: "Hide",
            chooseStyle: "Choose style",
            removeChanges: "Remove changes",
            zoomIn: "Zoom in",
            growingStockEstimates: "Growing stock estimates",
            specifiedArea: "Specified area ",
            noData: "No data.",
            forestAnalyst: "Forest analyst",
            zoom: "Zoom",
            cadastre: "Cadastre",
            parcelNumber: "Parcel Number",
            supplierId: "Supplier ID",
            supplierName: "Supplier name",
            estimatedVolume: "Estimated volume (m3)",
            measuredVolume: "Measured volume (m3)",
            transporterId: "Transporter ID",
            transporterName: "Transporter name",
            mandantLegalCompany: "Mandant legal company",
            millName: "Mill name",
            woodTypeCZ: "Wood type",
            contractIdExternal: "Contract external ID",
            buyerId: "Buyer ID",
            sortimentText: "Sortiment text",
            source: "Source",
            lengthDescription: "Length description",
            IDEndCustomer: "End customer ID",
            dateOfLoading: "Date of loading",
            dateOfDelivery: "Date of delivery",
            loadingPlace: "Loading place",
            sortiment: "Sortiment ID",
            sortimentTXT: "Sortiment type text",
            LHPtoDate: "LHP Due date",
            LHCname: "LHC Name",
            LHPStand: "LHP Stand",
            LHPStandGroup: "ID stand group",
            ownerName: "Owner name",
            forestType: "Forest type",
            forestManager: "Forest manager",
            specName: "Species name",
            specCode: "Species code",
            treeHeight: "Tree height (m)",
            DBH: "DBH (cm)",
            avTreeVol: "Average tree size (m3)",
            growStock: "Growing stock (m3)",
            growStockHa: "Growing stock (m3/ha)",
            specRepre: "Species representation (%)",
            filter: "Filter",
            default: "Default",
            txMetric1: "1. Metric",
            txMetric2: "2. Metric",
            txType: "Type",
            txAction: "Action",
            speciesAltitude: "Species Altitude",
            woodStock: "Wood Stock",
            story: "Story",
            gray: 'Gray',
            green: 'Green',
            red: 'Red',
            help: 'help',
            selectChannel: 'Select channel',
            selectBuyer: 'Select purchaser',
            selectMill: 'Select mill',
            selectSupplier: 'Select supplier',
            selectWoodType: 'Select wood type',
            selectLanguage: 'Choose language',
            selectConfiguration: 'Select configuration',
            dateRange: "Date interval",
            spatialResolution: "Spatial resolution:",
            cloudCoverage: "Cloud coverage:",
            changeStrictness: "Threshold:",
            resolution: "resolution",
            resamplingTo: "Resampling to",
            method: "Method:",
            bands: "Bands:",
            overlapPrct: "Overlap percentage:",
            altImgIcon: "Legend icon",
            deviceType: "Device type",
            allDevices: "All devices",
            bandComposite: "Band composite"
        },
        message: {
            globalSearch: 'Search',
            geoJsonCopied: 'GeoJSON copied to clipboard!',
            zoomToStory: 'Zoom to the story',
            skysatHighResolution: 'SkySat high resolution imaginery.',
            falseColorBands: 'False color bands',
            changeDetection: 'Include to the change detection',
            switchGroup: 'Turn on/turn off the whole group',
            deactiveSwiping: 'Deactivate swipe',
            swipeThisLayer: 'Swipe this layer',
            sentinelImages: 'Sentinel images.',
            changeDetectionTitle: 'Change detection in the defined area.',
            changeSegmentation: 'Change segmentation',
            saveModification: 'Save modification',
            removeLastPoint: 'Remove last point',
            legendCannotBeDisplayed: 'Legend cannot be displayed. Please switch on at least one layer from layer switcher.',
            couldNotFindCompartment: "Could not find any forest compartment in this selection.",
            pleaseZoomIn: "Please zoom in to use this functionality.",
            selectedPlanHasNoAttributes: "Selected forest management plan doesn't have attributes to show.",
            tooManyPolygons: "Too many changes please mitigate the change detection treshold.",
            selectedGuidlinesHasNoAttributes: "Selected forest management guidelines doesn't have attributes to show.",
            pointVisibleOnTheMap: "It will be visible near the point on the map.",
            noteDescription: "Note description. It can be displayed after selection.",
            labelLength: "Label must be at most 50 characters long.",
            labelRequired: "Label is required.",
            mightHaveGaps: "Data might have gaps with",
            tooManyOrLow: "It can detect to many or low number of changes",
            cloudCoverage: 'cloud coverage',
            changeStrictness: "treshold value",
            authenticationError: "Authentication error please log out and log in again. When it doesn't work contact the forest monitoring team to help.",
            unauthorizedError: "Please contact the forest monitoring team to be able to access the application. It looks like you are here for the first time.",
            channelHasToBeSelected: "At least one channel has to be selected.",
            buyerHasToBeSelected: "At least one purchaser has to be selected.",
            optionalFilter: "Optional filter.",
            chooseInterval: "Select an interval.",
            addGeographicNameOrParcelNumber: "Add geographic name or parcel number.",
            searchFailed: "Search failed.",
            noResultsFound: "No results found.",
            chooseDevice: "Choose device type."
        },
        button: {
            line: 'Line',
            area: 'Area',
            circle: 'Circle',
            new: 'New',
            freehand: 'Freehand',
            submit: 'Submit',
            show: 'Show',
            clear: 'Clear',
            delete: 'Delete',
            save: 'Save',
            searchByPolygon: 'Polygon',
            searchByRectangle: 'Rectangle',
            basedOnMapView: 'Map view'
        },
        forestry: {
            age: 'Age ',
            ps: 'Ps ',
            density: 'Density of stocking ',
            hs: 'Forest management group',
            silviculturalOperations: 'Silvicultural operations',
            harvestingOperations: 'Harvesting operations',
            businessMeeting: 'Business meeting',
            barkBeetle: 'Bark beetle',
            roadSideLocation: 'Road side location'
        },
        layers_list: {
            //layers groups
            background: 'Background maps',
            satellite: 'Satellite',
            weather: 'Weather',
            business: 'Business',
            forestry: 'Forestry',
            protected: 'Protected',
            protectedOther: 'Protected (other)',
            //basemaps
            osm: 'OpenStreetMap',
            aerialPhotography: 'Aerial photography 2022/2023',
            aerialPhotography_2019_2020: 'Aerial photography 2019/2020',
            aerialPhotography_2017_2018: 'Aerial photography 2017/2018',
            planetMonth: 'PlanetScope monthly',
            buildingsNumber: 'Building with street number',
            DMR5G: 'Digital terrain model 5G',
            slope: 'Slope',
            more: 'more',
            aspect: 'Aspect',
            north: 'North',
            northEast: 'North-east',
            east: 'East',
            southEast: 'South-east',
            south: 'South',
            southWest: 'South-west',
            west: 'West',
            northWest: 'North-west',
            hillshade: 'Hillshade',
            topoMap: 'Topographic map',
            //forestry
            treeSpecies: 'Tree species',
            spruce: 'Spruce',
            beech: 'Beech',
            pine: 'Pine',
            oak: 'Oak',
            broadLeaved: 'Broad-leaved',
            kalwang1: 'Kalwang max. change 1.4.2024',
            kalwang2: 'Kalwang min. change 1.4.2024',
            coniferous: 'Coniferous',
            mountainPine: 'Mountain pine',
            crop: 'Crop',
            logging: 'Logging',
            change: 'Change',
            dronOrth20181120: 'Drone 20.11.2018',
            coniferousForest: 'Coniferous forest',
            standConiferousForest: 'Standing coniferous forest',
            forestGrowthStages: 'Forest growth stages',
            smallPoleStand: 'Small pole stand',
            poleTimberStand: 'Pole timber stand',
            thicket: 'Thicket',
            highForest: 'High Forest',
            barkBeetle: 'Bark beetle',
            deathTree: 'Death tree',
            reserve: 'Reserve',
            clearcut: 'Clearcut',
            area: 'Area',
            //business
            compartmentsLHP: 'Compartmnets LHP',
            fmGuidelines: 'FM guidelines',
            fmPlans: 'FM plans',
            compartContours: 'Compartments LHP - contours',
            compartStand: 'Compartments LHP - stand',
            compartStandLCR: 'Compartments LHP - stand (LČR)',
            compartContoursLCR: 'Compartments LHP - contours (LČR)',
            ageClass0: 'Age class 0',
            ageClass1: 'Age class 1 (1-20 years)',
            ageClass2: 'Age class 2 (21-40 years)',
            ageClass3: 'Age class 3 (41-60 years)',
            ageClass4: 'Age class 4 (61-80 years)',
            ageClass5: 'Age class 5 (81-100 years)',
            ageClass6: 'Age class 6 (101-120 years)',
            ageClass7: 'Age class 7 (121-140 years)',
            ageClass8: 'Age class 8 (>140 years)',
            oddeleniBoundary: 'Compartment boundary',
            dilecBoundary: 'Subcompartment boundary',
            dilecBoundaryVariant: 'Subcompartment boundary - variant',
            forestBorder: 'Forest border',
            border: 'Border',
            ownership: 'Ownership',
            lesyCR: 'Lesy ČR',
            stateForestVLS: 'State forests VLS',
            stateForestStrSk: 'State forests (Střední škola)',
            stateForestMZPNP: 'State forests MZP (NP)',
            stateForestMZPAOPK: 'State forests MZP (AOPK)',
            stateForestOther: 'State forests others',
            formerStateForest: 'Former state forests',
            municipalUrbanForest: 'Municipal and urban forests',
            ecclesiasticalForest: 'Ecclesiastical forests',
            legalEntity: 'Legal entity',
            individual: 'Individual',
            othersForest: 'Others',
            businessAreas: 'Business areas',
            zonePlana: 'Zones - Planá',
            zoneZdirec: 'Zones - Ždírec',
            zoneBrand: 'Zones - Brand',
            zoneYbbs: 'Zones - Ybbs',
            zoneBsLeonard: 'Zones - B.S. Leonard',
            lessThan: 'Less than 10 km',
            km10_20: '10 - 20 km',
            km20_40: '20 - 40 km',
            km40_60: '40 - 60 km',
            km60_80: '60 - 80 km',
            km80_100: '80 - 100 km',
            km100_120: '100 - 120 km',
            km120_140: '120 - 140 km',
            km140_160: '140 - 160 km',
            km160_180: '160 - 180 km',
            km180_200: '180 - 200 km',
            km200_220: '200 - 220 km',
            km220_240: '220 - 240 km',
            km240_260: '240 - 260 km',
            km260_280: '260 - 280 km',
            km280_300: '280 - 300 km',
            parcels: 'Parcels',
            purchaseArea: 'Purchase area',
            new: 'New',
            loadingPlace: 'Loading place',
            approxLocation: 'Approximate location',
            suppliers: 'Suppliers',
            delivery: 'Delivery',
            notes: 'Notes',
            //protected
            covenantProtectedArea: 'Covenant protected area',
            protectedArea: 'Protected area',
            protectedTree: 'Protected tree',
            stand: 'Stand',
            wetland: 'Wetland',
            //Small protected area
            smallProtectedArea: "Small special protected area",
            smallProtectedAreaPA: "Small special protected area (protected zone)",
            nationalNaturReser: 'National nature reservation',
            nationalNaturMonum: 'National natural monument',
            natureReservation: 'Nature reservation',
            naturalMonument: 'Natural monument',
            declarProtZone: 'Declared protection zone',
            protZoneLaw: 'Protective zone by law',
            //Memorial trees
            memorialTrees: 'Memorial tree',
            memorialTreesLine: 'Memorial tree - line',
            memorialTreesLineParticular: 'memorial trees without location of individuals - line',
            memorialTreesArea: 'Memorial tree - area',
            solitaire: 'solitaire',
            definitionPointAlley: 'definition point alley',
            alleyLocatedParticularTree: 'alley, located tree individual',
            memorialTreesAreaWithoutLocation: 'memorial trees without location of individuals - polygon',
            definitionPointGroup: 'definition point of a group',
            groupParticularTrees: 'group, located tree individual',
            //Zoning NP arrondissement
            zoningArrondissement: 'Zoning NP - arrondissement',
            arrondissementLaw: "area according to § 18 paragraph 3 of Act No. 114/1992 Coll.",
            //Quiet areas NP
            quietAreasNationalPark: "Quiet areas of national parcs",
            quietArea: "Quiet areas",
            //Large protected area
            largeProtectedAreaZoning: 'Large protected area zones',
            largeProtectedArea: 'Large protected area',
            borderCHKONP: 'Border of CHKO and NP',
            borderNPzoneA: 'NP - zone A - natural',
            borderNPzoneB: 'NP - zone B - near natural',
            borderNPzoneC: 'NP - zone C - concentrated care for nature',
            borderNPzoneD: 'NP - zone D - cultural landscape',
            borderCHKOI: 'CHKO - I. zone',
            borderCHKOII: 'CHKO - II. zone',
            borderCHKOIII: 'CHKO - III. zone',
            borderCHKOIV: 'CHKO - IV. zone',
            largeProtectedAreaOP: 'Large protected area - special and protection zone',
            nationalParkNP: 'national parc (NP)',
            protectedAreaNP: 'protected landscape area (CHKO)',
            protectionZones: 'protection zones (OP)',
            //European important site
            europeanImportantSites: 'European important sites (EVL)',
            europeanImportantSite: 'european important site',
            //Bird area
            birdAreas: 'Bird areas (PO)',
            birdArea: 'bird area',
            //Biosferic reserve zoning,
            biosphereReserveZoning: 'Zoning of biospheric reserve',
            zoneI: 'zone I',
            zoneII: 'zone II',
            zoneIII: 'zone III',
            //Conceptual definition supraregional biocenters
            conceptualDefinitionSupraregionalBiocenters: 'USES - conceptual definition of supraregional biocenters',
            zone: 'zone',
            //UNESCO World nature heritage
            worldNatureHeritageUNESCO: 'World nature heritage UNESCO',
            worldNatureHeritageSite: 'site - world nature heritage UNESCO',
            landscapeCareZoneAndSustainableDevelopment: 'landscape care zone and sustainable development',
            protectionZone: 'protection zone',
            //Nationally important species
            nationallyImportantSpecies: "Nationally important species locations",
            //Geoparc
            geoparc: 'Geoparc',
            geoparcUNESCO: 'UNESCO geoparc',
            nationalGeoparc: 'national geoparc',
            geoparcCandidate: 'candidate geoparc',
            biotopeSpeciallyProtectedSpeciesLargeMammals: "Biotope of specially protected species of large mammals",
            coreArea: "core area",
            migrationCoridor: "migration coridor",
            criticalZone: "critical zone",
            //Ramsar
            ramsarWetlands: "Ramsar wetlands",
            //at_plus
            orthophoto: 'Orthophoto',
            mapOverlay: 'Map overlay',
            digSurfMod: 'Digital surface model',
            realEstates: 'Real estates',
            dominantTreeSp: 'Dominant tree species',
            spruceTannedDouglFir: 'Spruce and Tanned, Douglas fir',
            larch: 'Larch',
            spruceDouglasFir: 'Spruce, Douglas fir',
            stock: 'Stock',
            natura2000: 'Natura2000',
            naturalMonPoint: 'Natural monument - point',
            naturalMonArea: 'Natural monument - area',
            smallProtArea: 'Small protected area',
            forestPlan: 'Forest plan',
            purchaseArea2: 'Purchase areas - Austria',
            utilizFunction: 'Utilization function',
            protectFunction: 'Protection function',
            welfareFunction: 'Welfare function',
            objProtectFunction: 'Object protection function',
            objSiteProtectFunction: 'Object and/or site protection function',
            withoutProtectFunction: 'Without protection function',
            hazardZone: 'Hazard zone',
            moderateTorrentRisk: 'Moderate torrent risk',
            highTorrentRisk: 'High torrent risk',
            moderateAvalancheRisk: 'Moderate avalanche risk',
            highAvalancheRisk: 'High avalanche risk',
            reservationAreaBlue: 'Landslide area - blue',
            advisoryAreaBrown: 'Landslide advisory area - brown',
            advisoryAreaViolet: 'Landslide advisory area - violet',
            //de_plus
            orthoDOP80: 'Digitales Orthophoto DOP80',
            orthoDOPCIR80: 'Digitales Orthophoto DOPCIR80',
            topoDTK500: 'Topographic DTK500',
            webTopoKarte: 'Topographic web map',
            byLabel: 'Label overlay',
            sent2RGB: 'Sentinel2 - RGB (2021)',
            sent2NIR: 'Sentinel2 - NIR (2021)',
            sent2NIRRER: 'Sentinel2 - NIRRER (2021)',
            domTreeDe: 'Dominant tree species (2018)',
            forestMask: 'Forest mask (2018)',
            fir: 'Fir',
            douglasFir: 'Douglas fir',
            alder: 'Alder',
            birch: 'Birch',
            otherDecHigh: 'Other deciduous - high life expectancy',
            otherDecLow: 'Other deciduous - low life expectancy'
        },
        hint: {
            doneLabel: 'Done',
            prevLabel: 'Back',
            nextLabel: 'Next',
            title1: 'Welcome to the Forest monitoring',
            title2: 'Layer switcher',
            title3: 'Legend',
            title4: 'Forest compartments',
            title5: 'Real estates',
            title6: 'Satellite imagery',
            title7: 'Forest analyst',
            title8: 'User notes',
            title9: 'User profile',
            title10: 'Geolocation',
            title11: 'Map zoom',
            title12: 'Manual measurement',
            step1: 'Here you will find information about features and controls.',
            step2: 'Here you can activate and deactivate specific map layers, such as forest cover, parcel boundaries, etc.',
            step3: 'Here you can see the legend for specific map layers. There is a dependency between the active layer and the legend. For example: If the forest cover layer is active, you will see the related legend for that layer.',
            step4: 'The Forest Cover tool allows you to view detailed information about the covers. To specify an area of interest, you can use several tools. Draw the area manually, use a polygon, or use a point indicator.',
            step5: 'The Properties tool allows you to view detailed information about properties. To specify an area of interest, you can use several tools. Draw the area manually, use a polygon, or use a point indicator.',
            step6: 'This tool allows you to activate and deactivate satellite images of a specific area on the map.',
            step7: 'The Forest Cover Analysis tool allows you to view detailed information about forestry, such as the number of tree species, their average age, etc. All of this is dependent on elevation. To specify an area of interest, you can use several tools. Draw the area manually or use a polygon.',
            step8: 'This tool allows you to add your own note directly to the map.',
            step9: 'In this section, you will find information about your user account.',
            step10: 'Click this button to display your physical location on the map.',
            step11: 'This group of buttons is used to zoom in and out of the map. Zooming in and out can also be controlled using the mouse wheel when working on a computer or gestures on touch screens.',
            step12: 'This tool allows you to determine the size of an area on the map. You can use several options to mark the area (polygon, circle, line).',
        }
    },
    CZ: {
        title: {
            rowsPerPage: 'Řádků na stránku:',
            searchForParcel: "Hledat parcelu",
            searchForParcelOrGeographicName: "Hledat parcelu nebo geografický název",
            chooseLocation: "Vyber polohu",
            searchExample: "Např. 123/1 nebo geografické jméno",
            note: 'Poznámka',
            category: 'Kategorie',
            label: 'Titulek',
            legend: 'Legenda',
            userSetting: 'Uživatelské nastavení',
            logout: 'Odhlásit',
            noteFilter: 'Filtr poznámek',
            imagePreview: 'Náhled na obrázek',
            transparency: 'Průhlednost',
            swipe: ' Porovnat',
            realEstates: 'Hranice parcel',
            remoteSensing: 'Dálkový průzkum',
            delivery: 'Dodávky',
            ordering: 'Objednání',
            orderingSatellite: 'Objednání satelitních snímků',
            satelliteChanges: 'Změny ze satelitů',
            hidePanel: 'Schovat panel',
            manualMeasurement: 'Ruční měření',
            measureLine: 'Měření linie',
            searchByPolygon: 'Hledat v polygonu',
            searchByRectangle: 'Hledat v obdelníku',
            measureArea: 'Měření plochy',
            measureCircle: 'Měření kruhu',
            removeCurrentMeasurements: 'Odstranit současné měření',
            measurement: "Měření",
            clearMeasurements: "Smazat měření",
            storaensoLogo: "Logo StoraEnso",
            layerSwitcher: "Přepínač vrstev",
            layers: "Vrstvy",
            userNotes: "Uživatelské poznámky",
            forestCompartment: "Lesní porost",
            changeDetection: "Detekce změny",
            saveNote: "Uložení poznámky",
            analysis: "Analýza",
            droneMissions: "Mise dronů",
            falseColorBands: "Pásma s nepravými barvami",
            collapsePanel: "Sbalit panel",
            hideTab: "Skrýt tabulku",
            hide: "Skrýt",
            removeChanges: "Odstranit změny",
            zoomIn: "Přiblížit",
            growingStockEstimates: "Odhady zásob",
            specifiedArea: "Vybraná plocha ",
            noData: "Žádná data.",
            forestAnalyst: "Forest analyst",
            zoom: "Přiblížit",
            cadastre: "Katastr",
            parcelNumber: "Číslo parcely",
            supplierId: "ID dodavatele",
            supplierName: "Jméno dodavatele",
            estimatedVolume: "Odhad objemu (m3)",
            measuredVolume: "Změřený objem (m3)",
            transporterId: "ID přepravce",
            transporterName: "Jméno přepravce",
            mandantLegalCompany: "Společnost (mandant)",
            millName: "Jméno pily",
            woodTypeCZ: "Druh dřeva",
            contractIdExternal: "ID kontraktu (externí)",
            buyerId: "ID nákupčí",
            sortiment: "Sortiment",
            source: "Zdroj",
            lengthDescription: "Délky popis",
            IDEndCustomer: "ID koncový zákazník",
            dateOfLoading: "Datum nakládky",
            dateOfDelivery: "Datum doručení",
            loadingPlace: "Místo nakládky",
            sortimentID: "ID sortiment",
            sortimentTXT: "Sortiment popis",
            LHPtoDate: "Platnost LHP",
            LHCname: "Název LHC",
            LHPStand: "ID porostu",
            LHPStandGroup: "ID porostní skupiny",
            ownerName: "Název majitele",
            forestType: "Lesní typ",
            forestManager: "Odborný lesní hospodář",
            specName: "Druh stromu",
            specCode: "Kód stromu",
            treeHeight: "Výška stromu (m)",
            DBH: "DBH (cm)",
            avTreeVol: "Přibližný objem (m3)",
            growStock: "Zásoba v m3",
            growStockHa: "Zásoba v m3/ha",
            specRepre: "Zastoupení druhu (%)",
            filter: "Filtr",
            chooseStyle: "Vyber styl",
            default: "Defaultní",
            txMetric1: "1. Metrika",
            txMetric2: "2. Metrika",
            txType: "Typ",
            txAction: "Akce",
            speciesAltitude: "Výšková analýza",
            woodStock: "Zásoby dřeva",
            story: "Etáž",
            gray: 'Šedá',
            green: 'Zelená',
            red: 'Červená',
            help: 'Nápověda',
            selectChannel: 'Vyber kanál',
            selectBuyer: 'Vyber nákupčí',
            selectMill: 'Vyber pilu',
            selectSupplier: 'Vyber dodavatele',
            selectWoodType: 'Vyber druh dřeva',
            selectLanguage: 'Vyber jazyk',
            selectConfiguration: 'Vyber konfiguraci',
            dateRange: "Datum interval",
            spatialResolution: "Prostorové rozlišení:",
            resolution: "rozlišení",
            resamplingTo: "Převzorkování na",
            cloudCoverage: 'Pokrytí mraky:',
            changeStrictness: "Práh:",
            altImgIcon: "Ikona legenda",
            deviceType: "Typ zařízení",
            allDevices: "Všechna zařízení",
            bandComposite: "Kompozice pásma"
        },
        message: {
            globalSearch: 'Vyhledávání',
            geoJsonCopied: 'GeoJSON byl zkopírován do schránky!',
            zoomToStory: 'Přiblížit na etáž',
            skysatHighResolution: 'SkySat s vysokým prostorovým rozlišením.',
            falseColorBands: 'Kompozice v nepravých barvách',
            changeDetection: 'Zahrnout vrstvu do detekce změn',
            switchGroup: 'Zapnout/Vypnout celou skupinu',
            deactiveSwiping: 'Vypnout porovnání',
            swipeThisLayer: 'Porovnat tuto vrstvu',
            sentinelImages: 'Sentinel snímky.',
            changeDetectionTitle: 'Detekované změny ve zvolené oblasti.',
            changeSegmentation: 'Hranice změn',
            saveModification: 'Uložit editace',
            removeLastPoint: 'Odstranit poslední bod',
            legendCannotBeDisplayed: 'Nelze zobrazit legendu. Prosím zapněte aspoň jednu vrstvu, která má legendu.',
            couldNotFindCompartment: "V tomto výběru nelze nalézt žádný lesní porost.",
            pleaseZoomIn: "Pro spuštění funkcionality mapu přibližte.",
            selectedPlanHasNoAttributes: "Vybraný lesní plán hodpodaření nemá žádné atributy k zobrazení.",
            tooManyPolygons: "Příliš mnoho změn prosím zmírněte práh pro detekci.",
            saveNoteWasUnsuccessful: "Nepodařilo se uložito poznámku.",
            selectedGuidlinesHasNoAttributes: "Vybraná směrnice lesního hospodářství nemá žádné atributy k zobrazení.",
            pointVisibleOnTheMap: "Poznámka bude zobrazena jako bod v mapě..",
            noteDescription: "Popis poznámky. Bude viditelný po vybrání bodu v mapě.",
            labelLength: "Titulek musí mít maximálně 50 znaků.",
            labelRequired: "Titulek je povinný.",
            mightHaveGaps: "Data mohou obsahovat prázdná místa s",
            tooManyOrLow: "Může být detekováno příliš mnoho nebo málo změn",
            cloudCoverage: 'pokrytí oblačností',
            changeStrictness: "prahová hodnota",
            authenticationError: "Chyba autentifikace, odhlaste se a znovu se přihlaste. Když to nebude fungovat, kontaktujte forest monitoring tým, aby vám pomohl.",
            unauthorizedError: "Chcete-li získat přístup k aplikaci, kontaktujte tým forest monitoringu. Vypadá to, že jste tu poprvé.",
            channelHasToBeSelected: "Aspoň jeden kanál musí být vybraný.",
            buyerHasToBeSelected: "Aspoň jeden nákupčí musí být vybraný.",
            optionalFilter: "Nepovinný filtr.",
            chooseInterval: "Vyberte interval.",
            addGeographicNameOrParcelNumber: "Přidejte geografický název nebo číslo parcely.",
            searchFailed: "Vyhledávání selhalo.",
            noResultsFound: "Žádné výsledky nenalezeny.",
            chooseDevice: "Vyberte typ zařízení."
        },
        button: {
            line: 'Linie',
            area: 'Plocha',
            circle: 'Kruh',
            new: 'Nové',
            freehand: 'Ruční kreslení',
            submit: 'Poslat',
            show: 'Ukázat',
            clear: 'Vyčistit',
            delete: 'Smazat',
            save: 'Uložit',
            searchByRectangle: 'Obdelník'
        },
        forestry: {
            age: 'Věk',
            ps: 'Plocha PS',
            density: 'Zakmenění',
            hs: 'Hospodářský soubor',
            silviculturalOperations: 'Pěstební činnost',
            harvestingOperations: 'Těžební činnost',
            businessMeeting: 'Obchodní jednání',
            barkBeetle: 'Kůrovec'
        },
        layers_list: {
            //groups
            roadSideLocation: 'Odvozní místo',
            background: 'Základní',
            satellite: 'Satelitní',
            weather: 'Počasí',
            business: 'Business',
            forestry: 'Lesnické',
            protected: 'Ochrana přírody',
            protectedOther: 'Ochrana přírody (další)',
            //basemaps
            osm: 'OpenStreetMap',
            aerialPhotography: 'Letecké snímkování 2022/2023',
            aerialPhotography_2019_2020: 'Letecké snímkování 2019/2020',
            aerialPhotography_2017_2018: 'Letecké snímkování 2017/2018',
            planetMonth: 'PlanetScope měsíční',
            buildingsNumber: 'Budovy a čísla domů',
            DMR5G: 'Digitální model terénu 5G',
            slope: 'Sklon svahu',
            more: 'více',
            aspect: 'Orientace svahu',
            north: 'Sever',
            northEast: 'Severovýchod',
            east: 'Východ',
            southEast: 'Jihovýchod',
            south: 'Jih',
            southWest: 'Jihozápad',
            west: 'Západ',
            northWest: 'Severozápad',
            hillshade: 'Stínovaný reliéf',
            topoMap: 'Topografická mapa',
            //forestry
            treeSpecies: 'Druhy stromů',
            spruce: 'Smrk',
            beech: 'Buk',
            pine: 'Borovice',
            oak: 'Dub',
            broadLeaved: 'Listnaté - ostatní',
            kalwang1: 'Kalwang max. změny 1.4.2024',
            kalwang2: 'Kalwang min. změny 1.4.2024',
            coniferous: 'Jehličnaté - ostatní',
            mountainPine: 'Kleč',
            crop: 'Kultura',
            logging: 'Těžba',
            change: 'Změna',
            dronOrth20181120: 'Snímek z dronu 20.11.2018',
            coniferousForest: 'Jehličnatý les',
            standConiferousForest: 'Stojící jehličnatý porost',
            forestGrowthStages: 'Růstové fáze',
            smallPoleStand: 'Tyčkovina',
            poleTimberStand: 'Tyčovina',
            thicket: 'Mlazina',
            highForest: 'Kmenovina',
            barkBeetle: 'Kůrovec',
            deathTree: 'Mrtvý strom',
            reserve: 'Rezervace',
            clearcut: 'Holina',
            area: 'Plocha',
            //business
            fmGuidelines: 'Lesní hospodářské osnovy',
            fmPlans: 'Lesní hospodářské plány',
            ageClass0: 'Věková třída 0',
            ageClass1: 'Věková třída 1 (1-20 let)',
            ageClass2: 'Věková třída 2 (21-40 let)',
            ageClass3: 'Věková třída 3 (41-60 let)',
            ageClass4: 'Věková třída 4 (61-80 let)',
            ageClass5: 'Věková třída 5 (81-100 let)',
            ageClass6: 'Věková třída 6 (101-120 let)',
            ageClass7: 'Věková třída 7 (121-140 let)',
            ageClass8: 'Věková třída 8 (>140 let)',
            oddeleniBoundary: 'Hranice oddělení',
            dilecBoundary: 'Hranice dílce',
            dilecBoundaryVariant: 'Hranice dílce - varianta',
            cumulativeTemp: 'Kumulativní teploty',
            notes: 'Poznámky',
            compartContours: 'Obrysová mapa',
            compartContoursLCR: 'Obrysová mapa (LČR)',
            compartStand: 'Porostní mapa',
            compartStandLCR: 'Porostní mapa (LČR)',
            forestBorder: 'Hranice lesa',
            border: 'Hranice',
            ownership: 'Vlastnická struktura',
            lesyCR: 'Lesy ČR',
            stateForestVLS: 'Státní lesy VLS',
            stateForestStrSk: 'Státní lesy (Střední škola)',
            stateForestMZPNP: 'Státní lesy MZP (NP)',
            stateForestMZPAOPK: 'Státní lesy MZP (AOPK)',
            stateForestOther: 'Státní lesy ostatní',
            formerStateForest: 'Bývalo státní lesy',
            municipalUrbanForest: 'Obecní a městské lesy',
            ecclesiasticalForest: 'Církevní lesy',
            legalEntity: 'Právnické osoby',
            individual: 'Fyzická osoba',
            othersForest: 'Ostatní',
            businessAreas: 'Regiony nákupčích',
            zonePlana: 'Zóny odvozu - Planá',
            zoneZdirec: 'Zóny odvozu - Ždírec',
            zoneBrand: 'Zóny odvozu - Brand',
            zoneYbbs: 'Zóny odvozu - Ybbs',
            zoneBsLeonard: 'Zóny odvozu - B.S. Leonard',
            lessThan: 'Méně než 10 km',
            km10_20: '10 - 20 km',
            km20_40: '20 - 40 km',
            km40_60: '40 - 60 km',
            km60_80: '60 - 80 km',
            km80_100: '80 - 100 km',
            km100_120: '100 - 120 km',
            km120_140: '120 - 140 km',
            km140_160: '140 - 160 km',
            km160_180: '160 - 180 km',
            km180_200: '180 - 200 km',
            km200_220: '200 - 220 km',
            km220_240: '220 - 240 km',
            km240_260: '240 - 260 km',
            km260_280: '260 - 280 km',
            km280_300: '280 - 300 km',
            parcels: 'Hranice parcel',
            purchaseArea: 'Nákupní zóny',
            new: 'Nové',
            loadingPlace: 'Odvozní místa',
            approxLocation: 'Přibližná lokace',
            suppliers: 'Dodavatelé',
            delivery: 'Dodávky',
            //protected
            covenantProtectedArea: 'Smluvně chráněná území',
            protectedArea: 'Chráněné území',
            protectedTree: 'Chráněné stromy',
            stand: 'Porost',
            wetland: 'Mokřad',
            //Small protected area
            smallProtectedArea: "Maloplošná ZCHÚ",
            smallProtectedAreaPA: "Maloplošná ZCHÚ (ochranné pásmo)",
            nationalNaturReser: 'Národní přírodní rezervace (NPR)',
            nationalNaturMonum: 'Národní přírodní památka (NPP)',
            natureReservation: 'Přírodní rezervace (PR)',
            naturalMonument: 'Přírodní památka (PP)',
            declarProtZone: 'Vyhlášené ochranné pásmo',
            protZoneLaw: 'Ochranné pásmo ze zákona',
            //Memorial trees
            memorialTrees: 'Památný strom',
            memorialTreesLine: 'Památný strom - linie',
            memorialTreesLineParticular: 'památné stromy bez určení polohy jedinců - linie',
            memorialTreesArea: 'Památný strom - plocha',
            solitaire: 'solitér',
            definitionPointAlley: 'definiční bod aleje',
            alleyLocatedParticularTree: 'alej, zaměřený jednotlivý strom',
            memorialTreesAreaWithoutLocation: 'památné stromy - polygony bez polohy jednotlivců',
            definitionPointGroup: 'definiční bod skupiny',
            groupParticularTrees: 'skupina, zaměřený jednotlivý strom',
            //Zoning NP arrondissement
            zoningArrondissement: 'Zonace NP - arondace',
            arrondissementLaw: "území dle § 18 odst. 3 zák. č. 114/1992 Sb.",
            //Quiet areas NP
            quietAreasNationalPark: "Klidová území národních parků",
            quietArea: "klidové území",
            //Large protected area
            largeProtectedArea: 'Velkoplošná chráněná území',
            largeProtectedAreaZoning: 'Velkoplošná chráněná území zonace',
            borderCHKONP: 'Hranice mezi CHKO a NP',
            borderNPzoneA: 'NP - zóna A - přírodní',
            borderNPzoneB: 'NP - zóna B - přírodně blízká',
            borderNPzoneC: 'NP - zóna C - soustředěné péče o přírodu',
            borderNPzoneD: 'NP - zóna D - kulturní krajiny',
            borderCHKOI: 'CHKO - I. zóna',
            borderCHKOII: 'CHKO - II. zóna',
            borderCHKOIII: 'CHKO - III. zóna',
            borderCHKOIV: 'CHKO - IV. zóna',
            largeProtectedAreaOP: 'Velkoplošná ZCHÚ a OP',
            nationalParkNP: 'národní park (NP)',
            protectedAreaNP: 'chráněná krajinná oblast (CHKO)',
            protectionZones: 'ochranná pásma (OP)',
            //European important site
            europeanImportantSites: 'Evropsky významné lokality (EVL)',
            europeanImportantSite: 'evropsky významná lokalita',
            //Bird area
            birdAreas: 'Ptačí oblasti (PO)',
            birdArea: 'ptačí oblast',
            //Biosferic reserve zoning,
            biosphereReserveZoning: 'Zonace biosferických rezervací',
            zoneI: 'zóna I',
            zoneII: 'zóna II',
            zoneIII: 'zóna III',
            //Conceptual definition supraregional biocenters
            conceptualDefinitionSupraregionalBiocenters: 'USES - Koncepční vymezení nadregionálních biocenter',
            zone: 'zóna',
            //UNESCO World nature heritage
            worldNatureHeritageUNESCO: 'Světové přírodní dědictví UNESCO',
            worldNatureHeritageSite: 'lokalita světového přírodního dědictví UNESCO',
            landscapeCareZoneAndSustainableDevelopment: 'pásmo péče o krajinu a udržitelného rozvoje',
            protectionZone: 'ochranné pásmo',
            //Nationally important species
            nationallyImportantSpecies: "Lokality národně významných druhů",
            //Geoparc
            geoparc: 'Geoparky',
            geoparcUNESCO: 'UNESCO geopark',
            nationalGeoparc: 'národní geopark',
            geoparcCandidate: 'kandidátský geopark',
            biotopeSpeciallyProtectedSpeciesLargeMammals: "Biotop zvláště chráněných druhů velkých savců",
            coreArea: "jádrová území",
            migrationCoridor: "migrační koridor",
            criticalZone: "kritická místa",
            //Ramsar
            ramsarWetlands: "Mokřady Ramsarské úmluvy",
            //at_plus
            forestPlan: 'Rozdělení lesa dle využití',
            utilizFunction: 'užitná funkce',
            protectFunction: 'ochranná funkce',
            welfareFunction: 'sociální funkce',
            objProtectFunction: 'Les s funkcí ochrany objektů',
            objSiteProtectFunction: 'Les s funkcí ochrany objektů a/nebo stanovišť',
            withoutProtectFunction: 'Les bez ochranné funkce',
            hazardZone: 'Riziková zóna',
            moderateTorrentRisk: 'Střední riziko - bystřiny',
            highTorrentRisk: 'Vysoké riziko - bystřina',
            moderateAvalancheRisk: 'Střední riziko - laviny',
            highAvalancheRisk: 'Vysoké riziko - laviny',
            reservationAreaBlue: 'Rezervovaná oblast eroze - modrá',
            advisoryAreaBrown: 'Upozorňovací oblast eroze - hnědá',
            advisoryAreaViolet: 'Upozoňovací oblast eroze - fialová',
            purchaseArea2: 'Nákupní zóny - Rakousko',
            //basemaps
            orthophoto: 'Ortofoto',
            mapOverlay: 'Mapové popisky',
            digSurfMod: 'Digitální model povrchu',
            //forestry
            dominantTreeSp: 'Dominantní druh dřeviny',
            spruceTannedDouglFir: 'Smrk, jedle, douglaska',
            larch: 'Modřín',
            spruceDouglasFir: 'Smrk, douglaska',
            stock: 'Zásoba dřeva',
            //de_plus
            //basemaps
            orthoDOP80: 'Ortofoto DOP40',
            orthoDOPCIR80: 'Ortofoto DOPCIR80',
            topoDTK500: 'Topografická mapa DTK500',
            webTopoKarte: 'Webová topografická mapa',
            byLabel: 'Překryvná vrstva s popisky',
            sent2RGB: 'Sentinel2 - RGB (2021)',
            sent2NIR: 'Sentinel2 - NIR (2021)',
            sent2NIRRER: 'Sentinel2 - NIRRER (2021)',
            //forestry
            domTreeDe: 'Dominantní druhy dřevin (2018)',
            forestMask: 'Hranice lesa (2018)',
            fir: 'Jedle',
            douglasFir: 'Douglaska',
            alder: 'Olše',
            birch: 'Bříza',
            otherDecHigh: 'Další opadavé - dlouhá délka života ',
            otherDecLow: 'Další opadavé - krátká délka života',
            //others
            natura2000: 'Natura2000',
            realEstates: 'Hranice parcel',
            smallProtArea: 'Maloplošná chráněná území',
        },
        hint: {
            doneLabel: 'Hotovo',
            prevLabel: 'Zpět',
            nextLabel: 'Další',
            title1: 'Vítejte v aplikaci Forest monitoring',
            title2: 'Přepínač vrstev',
            title3: 'Legenda',
            title4: 'Lesní porost',
            title5: 'Nenovitosti',
            title6: 'Satelitní snímky',
            title7: 'Analýza lesních porostů',
            title8: 'Uživatelské poznámky',
            title9: 'Profil uživatele',
            title10: 'Pozice na mapě',
            title11: 'Přiblížení a oddálení',
            title12: 'Ruční měření',
            step1: 'Zde najdete informace o funkcích a ovládacích prvcích.',
            step2: 'Zde můžete aktivovat a deaktivovat konkrétní mapové vrstvy, např. lesní porosty, hranice parcel atd.',
            step3: 'Zde můžete vidět legendu pro konkrétní vrstvy mapy.Mezi aktivní vrstvou a legendou existuje závislost. Například: Pokud je aktivní vrstva lesních porostů, uvidíte související legendu této vrstvy.',
            step4: 'Nástroj Lesní porost vám umožňuje zobrazit podrobné informace o porostech. Pro specifikaci oblasti zájmu můžete použít několik nástrojů. Nakreslete oblast ručně, využijte mnohoúhelník nebo použijte ukazatel konkrétního bodu.',
            step5: 'Nástroj Nemovitosti umožňuje zobrazit podrobné informace o nemovitostech. Pro specifikaci oblasti zájmu můžete použít několik nástrojů. Nakreslete oblast ručně, využijte mnohoúhelník nebo použijte ukazatel konkrétního bodu.',
            step6: 'Tento nástroj umožňuje aktivovat a deaktivovat satelitní snímky konkrétní oblasti na mapě.',
            step7: 'Nástroj Analýza lesních porostů umožňuje zobrazit podrobné informace o lesnictví, např. počet druhů stromů, jejich průměrné stáří atd. To vše se závislostí na nadmořské výšce. Pro specifikaci oblasti zájmu můžete použít několik nástrojů. Nakreslete oblast ručně nebo využijte mnohoúhelník.',
            step8: 'Tento nástroj vám umožňuje přidat vlastní poznámku přímo do mapy.',
            step9: 'V této sekci naleznete informace týkající se vašeho uživatelského účtu.',
            step10: 'Kliknutím na toto tlačítko zobrazíte svou fyzickou polohu na mapě.',
            step11: 'Tato skupina tlačítek se používá pro přiblížení a oddálení mapy. Přiblížení a oddálení mapy lze ovládat taktéž kolečkem myši při práci na počítači nebo gesty na dotykových displejích.',
            step12: 'Tento nástroj umožňuje zjistit velikost oblasti na mapě. Pro označení oblasti můžete použít několik možností (polygon, kruh, čára).',
        }
    },
    AT: {
        title: {
            rowsPerPage: 'Zeilen pro Seite:',
            searchForParcel: "Suche nach Parzelle",
            searchForParcelOrGeographicName: "Suche nach Parzelle oder geografischem Namen",
            chooseLocation: "Wählen Sie einen Ort",
            searchExample: "Beispiel: 1234/2, or geografischer Name",
            note: 'Notiz',
            legend: 'Legende',
            label: 'Etikett',
            category: 'Kategorie',
            userSetting: 'Benutzereinstellung',
            logout: 'Ausloggen',
            noteFilter: 'Hinweisfilter',
            imagePreview: 'Bildvorschau',
            transparency: 'Transparenzgrad',
            swipe: ' Vergleichen',
            realEstates: 'Grundstücksgrenzen',
            remoteSensing: 'Fernerkundung',
            delivery: 'Lieferung',
            ordering: 'Bestellung',
            orderingSatellite: 'Bestellung von Satellitenbildern',
            satelliteChanges: 'Änderungen durch Satelliten',
            hidePanel: 'Verbergen',
            manualMeasurement: 'Händische Messung',
            measureLine: 'Messlinie',
            searchByPolygon: 'Suche nach Polygon',
            searchByRectangle: 'Suche nach Rechteck',
            measureArea: 'Messbereich',
            measureCircle: 'Messkreis',
            removeCurrentMeasurements: 'Löschen aktueller Messungen',
            measurement: "Messung",
            clearMeasurements: "Löschen Messungen",
            storaensoLogo: "Logo StoraEnso",
            layerSwitcher: "Layer Wechsel",
            layers: "Layers",
            userNotes: "Benutzernotizen",
            forestCompartment: "Waldabteil",
            analysis: "Analyse",
            droneMissions: "Drohnen-Missionen",
            falseColorBands: 'Falsche Farbbänder',
            changeDetection: 'Schließen Sie eine Ebene in die Änderungserkennung ein',
            collapsePanel: "Verbergen",
            hideTab: "Ergebnis ausblenden",
            hide: "Ausblenden",
            removeChanges: "Änderungen entfernen",
            zoomIn: "Vergrößern",
            growingStockEstimates: "Schätzung der Holzvorräte",
            specifiedArea: 'Auswahl Fläche',
            noData: "Keine Daten.",
            forestAnalyst: 'Waldanalyse',
            zoom: 'Vergrößern',
            chooseStyle: "Wählen Sie einen Stil",
            cadastre: 'Waldkataster',
            parcelNumber: 'Grundbuchnummer',
            supplierId: "Lieferanten-ID",
            supplierName: "Lieferantenname",
            estimatedVolume: "Geschätztes Volumen (m3)",
            measuredVolume: "Gemessenes Volumen (m3)",
            transporterId: "Transporteur-ID",
            transporterName: "Name des Transporteurs",
            mandantLegalCompany: "Mandantenrechtsfirma",
            millName: "Name der Mühle",
            woodTypeCZ: "Holzart",
            contractIdExternal: "Vertrags-ID (extern)",
            buyerId: "Käufer-ID",
            sortiment: "Sortiment",
            source: "Quelle",
            lengthDescription: "Length description",
            IDEndCustomer: "Endkunden-ID",
            dateOfLoading: "Ladedatum",
            dateOfDelivery: "Lieferdatum",
            loadingPlace: "Ladeplatz",
            sortimentID: "Sortiment-ID",
            sortimentTXT: "Sortimentstyp-Text",
            ownerName: "Eigentümername",
            forestType: "Waldtyp",
            forestManager: "Förster",
            filter: "Filter",
            txMetric1: "1. Metrisch",
            txMetric2: "2. Metrisch",
            txType: "Typ",
            txAction: "Aktion",
            woodStock: "Holzvorrat",
            story: "Boden",
            gray: 'Grau',
            green: 'Grün',
            red: 'Rot',
            help: 'Hilfe',
            cloudCoverage: 'Bewölkung:',
            changeStrictness: "Schwelle:",
            default: "Ursprünglich",
            selectChannel: 'Kanal auswählen',
            selectBuyer: 'Wähle einen Käufer',
            selectMill: 'Mühle auswählen',
            selectSupplier: 'Anbieter auswählen',
            selectWoodType: 'Holzart auswählen',
            selectLanguage: 'Sprache wählen',
            selectConfiguration: 'Konfiguration auswählen',
            dateRange: "Datumsintervall",
            spatialResolution: "Räumliche Auflösung:",
            resolution: "auflösung",
            resamplingTo: "Resampling zu",
            altImgIcon: "Legenden-Icon",
            deviceType: "Gerätetyp",
            allDevices: "Alle Geräte",
            bandComposite: "Bandkomposition"
        },
        message: {
            globalSearch: 'Suche',
            geoJsonCopied: 'GeoJSON in die Zwischenablage kopiert!',
            zoomToStory: 'Vergrößern des Bereichs',
            skysatHighResolution: 'Skysat Hohe Auflösung',
            falseColorBands: 'Falsche Farbbänder',
            changeDetection: 'Schließen Sie eine Ebene in die Änderungserkennung ein',
            switchGroup: 'Schalten Sie die gesamte Gruppe ein/aus',
            deactiveSwiping: 'Deaktivieren Vergleichen',
            swipeThisLayer: 'Layer-Vergleich',
            sentinelImages: 'Sentinel Satellitenbilder.',
            changeDetectionTitle: 'Änderungserkennung im definierten Bereich.',
            changeSegmentation: 'Änderung der Grenzen',
            saveModification: 'Änderungen speichern',
            removeLastPoint: 'Letzten Punkt entfernen',
            legendCannotBeDisplayed: 'Legende kann nicht angezeigt werden (schalte wenigstens eine Mape, welche eine Legende hat)',
            pleaseZoomIn: "Bitte vergrößern",
            tooManyPolygons: "Zu viele Änderungen, bitte senken Sie die Erkennungsschwelle.",
            saveNoteWasUnsuccessful: 'Speicherung der Notiz fehlgeschlagen.',
            selectedGuidlinesHasNoAttributes: 'Ausgewähltes auf der Forstkarte zeigt keine Eigenschaften.',
            pointVisibleOnTheMap: 'Bemerkung wird als Punkt auf der Karte angezeigt.',
            noteDescription: 'Beschreibung der Notiz. Es wird sichtbar, nachdem Sie den Punkt auf der Karte ausgewählt haben.',
            labelLength: 'Beschriftung darf max. 50 Zeichen lang sein',
            labelRequired: 'Beschriftung ist erforderlich.',
            mightHaveGaps: "Daten können Lücken aufweisen",
            tooManyOrLow: "Es kann zu viele oder zu wenige Änderungen erkennen",
            cloudCoverage: 'bewölkung',
            changeStrictness: "schwelle",
            authenticationError: "Authentifizierungsfehler Bitte abmelden und erneut anmelden. Wenn es nicht funktioniert, wenden Sie sich an das Waldüberwachungsteam, um Hilfe zu erhalten.",
            unauthorizedError: "Bitte wenden Sie sich an das Waldüberwachungsteam, um auf die Anwendung zugreifen zu können. Es sieht so aus, als wären Sie zum ersten Mal hier.",
            channelHasToBeSelected: "Es muss mindestens ein Kanal ausgewählt werden.",
            buyerHasToBeSelected: "Es muss mindestens ein Käufer ausgewählt werden.",
            optionalFilter: "Optionaler Filter.",
            chooseInterval: "Wähle ein Intervall aus.",
            addGeographicNameOrParcelNumber: "Fügen Sie einen geografischen Namen oder eine Parzellennummer hinzu.",
            searchFailed: "Suche fehlgeschlagen.",
            noResultsFound: "Keine Ergebnisse gefunden.",
            chooseDevice: "Wählen Sie einen Gerätetyp."
        },
        button: {
            line: 'Linie',
            area: 'Bereich',
            circle: 'Kreis',
            new: 'Neu',
            freehand: 'Freihandzeichnung',
            submit: 'Einreichen',
            show: 'Zeigen',
            clear: 'Reinigen',
            delete: 'Löschen',
            save: 'Auferlegen',
            searchByRectangle: 'Rechteck',
            basedOnMapView: 'Kartenausdehnung'
        },
        forestry: {
            age: 'Alter',
            hs: 'Bewirtschaftungseinheit',
            silviculturalOperations: 'Anbautätigkeit',
            harvestingOperations: 'Bergbautätigkeit',
            businessMeeting: 'Geschäftstreffen',
            barkBeetle: 'Ein Borkenkäfer',
            roadSideLocation: 'Lage am Straßenrand'
        },
        layers_list: {
            //groups
            background: 'Basiskarte',
            satellite: 'Satellite',
            weather: 'Wetter',
            business: 'Business',
            forestry: 'Forstwirtschaft',
            protected: 'Naturschutz',
            protectedOther: 'Naturschutz (mehr)',
            //basemaps
            osm: 'OpenStreetMap',
            hillshade: 'Geländeoberflächenkare',
            planetMonth: 'PlanetScope monatlich',
            topoMap: 'Topographische Karte',
            orthophoto: 'Orthophoto',
            mapOverlay: 'Überdeckung',
            digSurfMod: 'Digitale Oberflächenmodell',
            //forestry
            forestBorder: 'Waldrand',
            dominantTreeSp: 'Dominierende Baumart',
            spruceTannedDouglFir: 'Fichte und Tanned, Gewöhnliche Douglasie',
            larch: 'Lärche',
            spruceDouglasFir: 'Fichte und Tanne',
            pine: 'Kiefer',
            broadLeaved: 'Laubbaum',
            stock: 'Vorrats',
            kalwang1: 'Kalwang max. Änderung 1.4.2024',
            kalwang2: 'Kalwang min. Änderung 1.4.2024',
            //business
            zonePlana: 'Abholzonen - Planá',
            zoneZdirec: 'Abholzonen - Ždírec',
            zoneBrand: 'Abholzonen - Brand',
            zoneYbbs: 'Abholzonen - Ybbs',
            zoneBsLeonard: 'Abholzonen - B.S. Leonard',
            purchaseArea2: 'Einkauefer regionen',
            area: 'Gebiete',
            border: 'Rand',
            parcels: 'Parcels',
            purchaseArea: 'Rundholzeinkäufergebiete',
            new: 'Neu',
            loadingPlace: 'Ladeplatz',
            realEstates: 'Grundstücksgrenzen',
            //protected
            protectedTree: 'Naturdenkmalpunkt',
            wetland: 'Feuchtgebiet',
            natura2000: 'Europaschutzgebiete (Natura 2000)',
            smallProtArea: 'Naturdenkmalbereich',
            largeProtectedArea: 'Großräumige Schutzgebiete',
            //de_plus
            //basemaps
            orthoDOP80: 'Digitales Orthophoto 40cm (DOP40)',
            orthoDOPCIR80: 'Digitales Orthophoto DOPCIR80',
            topoDTK500: 'Digitale Topographische Karte',
            webTopoKarte: 'Web Topographische Karte',
            byLabel: 'Überlagerung mit Beschriftungen',
            sent2RGB: 'Sentinel2 - RGB (2021)',
            sent2NIR: 'Sentinel2 - NIR (2021)',
            sent2NIRRER: 'Sentinel2 - NIRRER (2021)',
            //forestry
            domTreeDe: 'Dominierende Baumart (2018)',
            forestMask: 'Waldrand (2018)',
            spruce: 'Fichte',
            fir: 'Tannen',
            douglasFir: 'Douglasien',
            beech: 'Buchen',
            oak: 'Eichen',
            alder: 'Erlen',
            birch: 'Birken',
            otherDecHigh: 'Andere Laubbäume - hohe Lebenserwartung',
            otherDecLow: 'Andere Laubbäume - geringe Lebenserwartung',
            forestPlan: 'Waldentwicklungsplan',
            utilizFunction: 'Nutzfunktion',
            protectFunction: 'Schutzfunktion',
            welfareFunction: 'Wohlfahrtsfunktion',
            objProtectFunction: 'Wald mit Objektschutzfunktion',
            objSiteProtectFunction: 'Wald mit Objekt- und/oder Standortschutzfunktion',
            withoutProtectFunction: 'Wald ohne vorrangige Schutzfunktion',
            hazardZone: 'Raumrelevanter Bereich',
            moderateTorrentRisk: 'Gelbe Summenzone Wildbach',
            highTorrentRisk: 'Rote Summenzone Wildbach',
            moderateAvalancheRisk: 'Gelbe Summenzone Lawine',
            highAvalancheRisk: 'Rote Summenzone Lawine',
            reservationAreaBlue: 'Vorbehaltsbereich Blau',
            advisoryAreaBrown: 'Hinweisbereich Braun',
            advisoryAreaViolet: 'Hinweisbereich Violet',
            ageClass0: 'Altersklasse 0',
            ageClass1: 'Altersklasse 1 (1-20 Jahre)',
            ageClass2: 'Altersklasse 2 (21-40 Jahre)',
            ageClass3: 'Altersklasse 3 (41-60 Jahre)',
            ageClass4: 'Altersklasse 4 (61-80 Jahre)',
            ageClass5: 'Altersklasse 5 (81-100 Jahre)',
            ageClass6: 'Altersklasse 6 (101-120 Jahre)',
            ageClass7: 'Altersklasse 7 (121-140 Jahre)',
            ageClass8: 'Altersklasse 8 (>140 Jahre)',
            oddeleniBoundary: 'Abteilungsgrenze',
            dilecBoundary: 'Unterabteilungsgrenze',
            dilecBoundaryVariant: 'Unterabteilungsgrenze - Variante',
        },
        hint: {
            doneLabel: 'Fertig',
            prevLabel: 'Zurück',
            nextLabel: 'Weiter',
            title1: 'Willkommen im Forest  monitoring',
            title2: 'Layer Wechsel',
            title3: 'Legende',
            title4: 'Waldbestand',
            title5: 'Grundstück',
            title6: 'Satellitenaufnahme',
            title7: 'Analyse des Waldbestands',
            title8: 'Benutzernotizen',
            title9: 'Benutzerprofil',
            title10: 'Kartenposition',
            title11: 'Vergrößern und Verkleinern',
            title12: 'Händische Messung',
            step1: 'Hier finden Sie Informationen zu Funktionen und Bedienelementen.',
            step2: 'Hier können Sie bestimmte Kartenebenen aktivieren und deaktivieren, z. B. Waldflächen, Parzellengrenzen usw.',
            step3: 'Hier können Sie die Legende für bestimmte Kartenebenen anzeigen. Es gibt eine Abhängigkeit zwischen der aktiven Ebene und der Legende. Zum Beispiel: Wenn die Waldflächen-Ebene aktiv ist, sehen Sie die zugehörige Legende dieser Ebene.',
            step4: 'Das Tool Waldflächen ermöglicht es Ihnen, detaillierte Informationen zu den Flächen anzuzeigen. Sie können mehrere Werkzeuge verwenden, um ein Interessengebiet zu spezifizieren. Zeichnen Sie das Gebiet manuell, verwenden Sie ein Polygon oder nutzen Sie den Punktzeiger.',
            step5: 'Das Tool Immobilien ermöglicht es, detaillierte Informationen zu Immobilien anzuzeigen. Um ein Interessengebiet zu spezifizieren, können Sie mehrere Werkzeuge verwenden. Zeichnen Sie das Gebiet manuell, verwenden Sie ein Polygon oder nutzen Sie den Punktzeiger.',
            step6: 'Dieses Tool ermöglicht es, Satellitenbilder für einen bestimmten Bereich auf der Karte zu aktivieren und zu deaktivieren.',
            step7: 'Das Tool Analyse der Waldflächen ermöglicht es, detaillierte Informationen zur Forstwirtschaft anzuzeigen, z. B. die Anzahl der Baumarten, ihr durchschnittliches Alter usw. All dies in Abhängigkeit von der Höhenlage. Um ein Interessengebiet zu spezifizieren, können Sie mehrere Werkzeuge verwenden. Zeichnen Sie das Gebiet manuell oder verwenden Sie ein Polygon.',
            step8: 'Dieses Tool ermöglicht es Ihnen, eine eigene Notiz direkt auf der Karte hinzuzufügen.',
            step9: 'In diesem Abschnitt finden Sie Informationen zu Ihrem Benutzerkonto.',
            step10: 'Klicken Sie auf diese Schaltfläche, um Ihre physische Position auf der Karte anzuzeigen.',
            step11: 'Diese Gruppe von Schaltflächen wird verwendet, um die Karte zu vergrößern und zu verkleinern. Die Zoom-Funktion kann auch mit dem Mausrad oder mit Gesten auf Touchscreens gesteuert werden.',
            step12: 'Dieses Tool ermöglicht es, die Größe eines Bereichs auf der Karte zu ermitteln. Sie können mehrere Optionen verwenden, um den Bereich zu markieren (Polygon, Kreis, Linie).',
        }
    },
    GER: {
        title: {
            rowsPerPage: 'Zeilen pro Seite:',
            searchForParcel: "Suche nach Parzelle",
            searchForParcelOrGeographicName: "Suche nach Parzelle oder geografischem Namen",
            chooseLocation: "Wählen Sie einen Ort",
            searchExample: "Beispiel: 1234/2, or geografischer Name",
            note: 'Notiz',
            legend: 'Legende',
            label: 'Etikett',
            category: 'Kategorie',
            userSetting: 'Benutzereinstellung',
            logout: 'Ausloggen',
            noteFilter: 'Hinweisfilter',
            imagePreview: 'Bildvorschau',
            transparency: 'Transparenzgrad',
            swipe: ' Vergleichen',
            realEstates: 'Grundstücksgrenzen',
            remoteSensing: 'Fernerkundung',
            ordering: 'Bestellung',
            orderingSatellite: 'Bestellung von Satellitenbildern',
            satelliteChanges: 'Änderungen durch Satelliten',
            hidePanel: 'Verbergen',
            manualMeasurement: 'Händische Messung',
            measureLine: 'Messlinie',
            searchByPolygon: 'Suche nach Polygon',
            searchByRectangle: 'Suche nach Rechteck',
            measureArea: 'Messbereich',
            measureCircle: 'Messkreis',
            removeCurrentMeasurements: 'Löschen aktueller Messungen',
            measurement: "Messung",
            clearMeasurements: "Löschen Messungen",
            storaensoLogo: "Logo StoraEnso",
            layerSwitcher: "Layer Wechsel",
            layers: "Layers",
            userNotes: "Benutzernotizen",
            forestCompartment: "Waldabteil",
            changeDetection: "Änderungserkennung",
            analysis: "Analyse",
            droneMissions: "Drohnen-Missionen",
            falseColorBands: 'Falsche Farbbänder',
            collapsePanel: "Verbergen",
            hideTab: "Ergebnis ausblenden",
            hide: "Ausblenden",
            chooseStyle: "Wählen Sie einen Stil",
            removeChanges: "Änderungen entfernen",
            zoomIn: "Vergrößern",
            growingStockEstimates: "Schätzung der Holzvorräte",
            specifiedArea: 'Auswahl Fläche',
            noData: "Keine Daten.",
            forestAnalyst: 'Waldanalyse',
            zoom: 'Vergrößern',
            cadastre: 'Waldkataster',
            parcelNumber: 'Grundbuchnummer',
            supplierId: "Lieferanten-ID",
            supplierName: "Lieferantenname",
            estimatedVolume: "Geschätztes Volumen (m3)",
            measuredVolume: "Gemessenes Volumen (m3)",
            transporterId: "Transporteur-ID",
            transporterName: "Name des Transporteurs",
            mandantLegalCompany: "Mandantenrechtsfirma",
            millName: "Name der Mühle",
            woodTypeCZ: "Holzart",
            contractIdExternal: "Vertrags-ID (extern)",
            buyerId: "Käufer-ID",
            sortiment: "Sortiment",
            source: "Quelle",
            IDEndCustomer: "Endkunden-ID",
            dateOfLoading: "Ladedatum",
            dateOfDelivery: "Lieferdatum",
            loadingPlace: "Ladeplatz",
            sortimentID: "Sortiment-ID",
            sortimentTXT: "Sortimentstyp-Text",
            ownerName: "Eigentümername",
            forestType: "Waldtyp",
            forestManager: "Förster",
            txMetric1: "1. Metrisch",
            default: "Ursprünglich",
            txMetric2: "2. Metrisch",
            txType: "Typ",
            txAction: "Aktion",
            woodStock: "Holzvorrat",
            story: "Boden",
            gray: 'Grau',
            green: 'Grün',
            red: 'Rot',
            help: 'Hilfe',
            cloudCoverage: 'Bewölkung:',
            changeStrictness: "Schwelle:",
            selectChannel: 'Kanal auswählen',
            selectBuyer: 'Wähle einen Käufer',
            selectMill: 'Mühle auswählen',
            selectSupplier: 'Anbieter auswählen',
            selectWoodType: 'Holzart auswählen',
            selectLanguage: 'Sprache wählen',
            selectConfiguration: 'Konfiguration auswählen',
            dateRange: "Datumsintervall",
            spatialResolution: "Räumliche Auflösung:",
            resolution: "auflösung",
            resamplingTo: "Resampling zu",
            altImgIcon: "Legenden-Icon",
            deviceType: "Gerätetyp",
            allDevices: "Alle Geräte",
            bandComposite: "Bandkomposition"
        },
        message: {
            globalSearch: 'Suche',
            geoJsonCopied: 'GeoJSON in die Zwischenablage kopiert!',
            zoomToStory: 'Vergrößern des Bereichs',
            skysatHighResolution: 'Skysat Hohe Auflösung',
            falseColorBands: 'Falsche Farbbänder',
            changeDetection: 'Schließen Sie eine Ebene in die Änderungserkennung ein',
            switchGroup: 'Schalten Sie die gesamte Gruppe ein/aus',
            deactiveSwiping: 'Deaktivieren Vergleichen',
            swipeThisLayer: 'Layer-Vergleich',
            sentinelImages: 'Sentinel Satellitenbilder.',
            changeDetectionTitle: 'Änderungserkennung im definierten Bereich.',
            changeSegmentation: 'Änderung der Grenzen',
            saveModification: 'Änderungen speichern',
            removeLastPoint: 'Letzten Punkt entfernen',
            legendCannotBeDisplayed: 'Legende kann nicht angezeigt werden (schalte wenigstens eine Mape, welche eine Legende hat)',
            pleaseZoomIn: "Bitte vergrößern",
            tooManyPolygons: "Zu viele Änderungen, bitte senken Sie die Erkennungsschwelle.",
            saveNoteWasUnsuccessful: 'Speicherung der Notiz fehlgeschlagen.',
            selectedGuidlinesHasNoAttributes: 'Ausgewähltes auf der Forstkarte zeigt keine Eigenschaften.',
            pointVisibleOnTheMap: 'Bemerkung wird als Punkt auf der Karte angezeigt.',
            noteDescription: 'Beschreibung der Notiz. Es wird sichtbar, nachdem Sie den Punkt auf der Karte ausgewählt haben.',
            labelLength: 'Beschriftung darf max. 50 Zeichen lang sein',
            labelRequired: 'Beschriftung ist erforderlich.',
            mightHaveGaps: "Daten können Lücken aufweisen",
            tooManyOrLow: "Es kann zu viele oder zu wenige Änderungen erkennen",
            cloudCoverage: 'bewölkung',
            changeStrictness: "schwelle",
            authenticationError: "Authentifizierungsfehler Bitte abmelden und erneut anmelden. Wenn es nicht funktioniert, wenden Sie sich an das Waldüberwachungsteam, um Hilfe zu erhalten.",
            unauthorizedError: "Bitte wenden Sie sich an das Waldüberwachungsteam, um auf die Anwendung zugreifen zu können. Es sieht so aus, als wären Sie zum ersten Mal hier.",
            channelHasToBeSelected: "Es muss mindestens ein Kanal ausgewählt werden.",
            buyerHasToBeSelected: "Es muss mindestens ein Käufer ausgewählt werden.",
            optionalFilter: "Optionaler Filter.",
            chooseInterval: "Wähle ein Intervall aus.",
            addGeographicNameOrParcelNumber: "Fügen Sie einen geografischen Namen oder eine Parzellennummer hinzu.",
            searchFailed: "Suche fehlgeschlagen.",
            noResultsFound: "Keine Ergebnisse gefunden.",
            chooseDevice: "Wählen Sie einen Gerätetyp."
        },
        button: {
            line: 'Linie',
            area: 'Bereich',
            circle: 'Kreis',
            new: 'Neu',
            freehand: 'Freihandzeichnung',
            submit: 'Einreichen',
            show: 'Zeigen',
            clear: 'Reinigen',
            delete: 'Löschen',
            save: 'Auferlegen',
            searchByRectangle: 'Rechteck',
            basedOnMapView: 'Kartenausdehnung'
        },
        forestry: {
            age: 'Alter',
            hs: 'Bewirtschaftungseinheit',
            silviculturalOperations: 'Anbautätigkeit',
            harvestingOperations: 'Bergbautätigkeit',
            businessMeeting: 'Geschäftstreffen',
            barkBeetle: 'Ein Borkenkäfer'
        },
        layers_list: {
            //layers groups
            background: 'Basiskarte',
            satellite: 'Satellite',
            weather: 'Wetter',
            business: 'Business',
            forestry: 'Forstwirtschaft',
            protected: 'Naturschutz',
            protectedOther: 'Naturschutz (mehr)',
            //basemaps
            orthoDOP80: 'Digitales Orthophoto DOP80',
            orthoDOPCIR80: 'Digitales Orthophoto DOPCIR80',
            topoDTK500: 'Topographic DTK500',
            webTopoKarte: 'Topographic web map',
            byLabel: 'Map overlay with labels',
            sent2RGB: 'Sentinel2 - RGB (2021)',
            sent2NIR: 'Sentinel2 - NIR (2021)',
            sent2NIRRER: 'Sentinel2 - NIRRER (2021)',
            //forestry
            pine: 'Kiefer',
            broadLeaved: 'Laubbaum',
            spruce: 'Fichte',
            kalwang1: 'Kalwang max. Änderung 1.4.2024',
            kalwang2: 'Kalwang min. Änderung 1.4.2024',
            larch: 'Lärche',
            fir: 'Tannen',
            douglasFir: 'Douglasien',
            beech: 'Buchen',
            oak: 'Eichen',
            alder: 'Erlen',
            birch: 'Birken',
            otherDecHigh: 'Andere Laubbäume - hohe Lebenserwartung',
            otherDecLow: 'Andere Laubbäume - geringe Lebenserwartung',
            domTreeDe: 'Dominierende Baumart (2018)',
            forestMask: 'Waldrand (2018)',
            //at_plus
            //basemaps
            osm: 'OpenStreetMap',
            hillshade: 'Geländeoberflächenkare',
            planetMonth: 'PlanetScope monatlich',
            topoMap: 'Topographische Karte',
            orthophoto: 'Orthophoto',
            mapOverlay: 'Überdeckung',
            digSurfMod: 'Digitale Oberflächenmodell',
            //forestry
            forestBorder: 'Waldrand',
            dominantTreeSp: 'Dominierende Baumart',
            spruceTannedDouglFir: 'Fichte und Tanned, Gewöhnliche Douglasie',
            spruceDouglasFir: 'Fichte und Tanne',
            stock: 'Vorrats',
            //business
            zonePlana: 'Abholzonen - Planá',
            zoneZdirec: 'Abholzonen - Ždírec',
            zoneBrand: 'Abholzonen - Brand',
            zoneYbbs: 'Abholzonen - Ybbs',
            zoneBsLeonard: 'Abholzonen - B.S. Leonard',
            area: 'Gebiete',
            border: 'Rand',
            parcels: 'Parcels',
            purchaseArea: 'Rundholzeinkäufergebiete',
            purchaseArea2: 'Einkauefer regionen',
            new: 'Neu',
            loadingPlace: 'Ladeplatz',
            realEstates: 'Grundstücksgrenzen',
            ageClass0: 'Altersklasse 0',
            ageClass1: 'Altersklasse 1 (1-20 Jahre)',
            ageClass2: 'Altersklasse 2 (21-40 Jahre)',
            ageClass3: 'Altersklasse 3 (41-60 Jahre)',
            ageClass4: 'Altersklasse 4 (61-80 Jahre)',
            ageClass5: 'Altersklasse 5 (81-100 Jahre)',
            ageClass6: 'Altersklasse 6 (101-120 Jahre)',
            ageClass7: 'Altersklasse 7 (121-140 Jahre)',
            ageClass8: 'Altersklasse 8 (>140 Jahre)',
            oddeleniBoundary: 'Abteilungsgrenze',
            dilecBoundary: 'Unterabteilungsgrenze',
            dilecBoundaryVariant: 'Unterabteilungsgrenze - Variante',
            //protected
            protectedTree: 'Naturdenkmalpunkt',
            wetland: 'Feuchtgebiet',
            natura2000: 'Europaschutzgebiete (Natura 2000)',
            smallProtArea: 'Naturdenkmalbereich',
            largeProtectedArea: 'Großräumige Schutzgebiete',
        },
        hint: {
            doneLabel: 'Fertig',
            prevLabel: 'Zurück',
            nextLabel: 'Weiter',
            title1: 'Willkommen im Forest  monitoring',
            title2: 'Layer Wechsel',
            title3: 'Legende',
            title4: 'Waldbestand',
            title5: 'Grundstück',
            title6: 'Satellitenaufnahme',
            title7: 'Analyse des Waldbestands',
            title8: 'Benutzernotizen',
            title9: 'Benutzerprofil',
            title10: 'Kartenposition',
            title11: 'Vergrößern und Verkleinern',
            title12: 'Händische Messung',
            step1: 'Hier finden Sie Informationen zu Funktionen und Bedienelementen.',
            step2: 'Hier können Sie bestimmte Kartenebenen aktivieren und deaktivieren, z. B. Waldflächen, Parzellengrenzen usw.',
            step3: 'Hier können Sie die Legende für bestimmte Kartenebenen anzeigen. Es gibt eine Abhängigkeit zwischen der aktiven Ebene und der Legende. Zum Beispiel: Wenn die Waldflächen-Ebene aktiv ist, sehen Sie die zugehörige Legende dieser Ebene.',
            step4: 'Das Tool Waldflächen ermöglicht es Ihnen, detaillierte Informationen zu den Flächen anzuzeigen. Sie können mehrere Werkzeuge verwenden, um ein Interessengebiet zu spezifizieren. Zeichnen Sie das Gebiet manuell, verwenden Sie ein Polygon oder nutzen Sie den Punktzeiger.',
            step5: 'Das Tool Immobilien ermöglicht es, detaillierte Informationen zu Immobilien anzuzeigen. Um ein Interessengebiet zu spezifizieren, können Sie mehrere Werkzeuge verwenden. Zeichnen Sie das Gebiet manuell, verwenden Sie ein Polygon oder nutzen Sie den Punktzeiger.',
            step6: 'Dieses Tool ermöglicht es, Satellitenbilder für einen bestimmten Bereich auf der Karte zu aktivieren und zu deaktivieren.',
            step7: 'Das Tool Analyse der Waldflächen ermöglicht es, detaillierte Informationen zur Forstwirtschaft anzuzeigen, z. B. die Anzahl der Baumarten, ihr durchschnittliches Alter usw. All dies in Abhängigkeit von der Höhenlage. Um ein Interessengebiet zu spezifizieren, können Sie mehrere Werkzeuge verwenden. Zeichnen Sie das Gebiet manuell oder verwenden Sie ein Polygon.',
            step8: 'Dieses Tool ermöglicht es Ihnen, eine eigene Notiz direkt auf der Karte hinzuzufügen.',
            step9: 'In diesem Abschnitt finden Sie Informationen zu Ihrem Benutzerkonto.',
            step10: 'Klicken Sie auf diese Schaltfläche, um Ihre physische Position auf der Karte anzuzeigen.',
            step11: 'Diese Gruppe von Schaltflächen wird verwendet, um die Karte zu vergrößern und zu verkleinern. Die Zoom-Funktion kann auch mit dem Mausrad oder mit Gesten auf Touchscreens gesteuert werden.',
            step12: 'Dieses Tool ermöglicht es, die Größe eines Bereichs auf der Karte zu ermitteln. Sie können mehrere Optionen verwenden, um den Bereich zu markieren (Polygon, Kreis, Linie).',
        }
    },
    PL: {
        title: {
            rowsPerPage: 'Wierszy na stronę:',
            searchForParcel: "Wyszukaj działkę",
            searchForParcelOrGeographicName: "Wyszukaj działkę lub nazwę geograficzną",
            chooseLocation: "Wybierz lokalizację",
            searchExample: "Np. 123/1 lub nazwa geograficzna",
            note: 'Notatka',
            label: 'Etykieta',
            category: 'Kategoria',
            legend: 'Legenda',
            userSetting: 'Ustawienia użytkownika',
            logout: 'Wyloguj się',
            noteFilter: 'Filtry notatek',
            imagePreview: 'Podgląd obrazu',
            transparency: 'Przezroczystość',
            swipe: 'Porównanie',
            realEstates: 'Nieruchomości',
            remoteSensing: 'Teledetekcja',
            delivery: 'Dostawa',
            ordering: 'Zamawianie',
            orderingSatellite: 'Zamawianie satelity',
            satelliteChanges: 'Zmiany satelitarne',
            hidePanel: 'Ukryj panel',
            manualMeasurement: 'Pomiary ręczne',
            measureLine: 'Mierz linię',
            searchByPolygon: 'Wyszukaj po poligonie',
            searchByRectangle: 'Wyszukaj po prostokącie',
            measureArea: 'Mierz powierzchnię',
            measureCircle: 'Mierz okrąg',
            removeCurrentMeasurements: 'Usuń bieżące pomiary',
            measurement: "Pomiary",
            clearMeasurements: "Wyczyść pomiary",
            storaensoLogo: "Logo StoraEnso",
            layerSwitcher: "Przełącznik warstw",
            layers: "Warstwy",
            userNotes: "Notatki użytkownika",
            forestCompartment: "Wydzielenie leśne",
            changeDetection: "Detekcja zmian",
            analysis: "Analiza",
            droneMissions: "Misje dronowe",
            falseColorBands: "Fałszywe kolory",
            collapsePanel: "Zwiń panel",
            hideTab: "Ukryj zakładkę",
            hide: "Ukryj",
            chooseStyle: "Wybierz styl",
            removeChanges: "Usuń zmiany",
            zoomIn: "Powiększ",
            growingStockEstimates: "Szacunki zapasów",
            specifiedArea: "Wybrany obszar",
            noData: "Brak danych.",
            forestAnalyst: "Analityk leśny",
            zoom: "Powiększ",
            cadastre: "Katastr",
            parcelNumber: "Numer działki",
            supplierId: "ID dostawcy",
            supplierName: "Nazwa dostawcy",
            estimatedVolume: "Szacowana objętość (m3)",
            measuredVolume: "Zmierzone wolumen (m3)",
            transporterId: "ID przewoźnika",
            transporterName: "Nazwa przewoźnika",
            mandantLegalCompany: "Firma zlecająca",
            millName: "Nazwa tartaku",
            woodTypeCZ: "Rodzaj drewna",
            contractIdExternal: "ID umowy zewnętrznej",
            buyerId: "ID kupującego",
            sortimentText: "Opis sortymentu",
            source: "Źródło",
            lengthDescription: "Opis długości",
            IDEndCustomer: "ID klienta końcowego",
            dateOfLoading: "Data załadunku",
            dateOfDelivery: "Data dostawy",
            loadingPlace: "Miejsce załadunku",
            sortiment: "ID sortymentu",
            sortimentTXT: "Typ sortymentu",
            LHPtoDate: "Data ważności PUL",
            LHCname: "Nazwa LHC",
            LHPStand: "ID wydzielenia",
            LHPStandGroup: "ID grupy wydzieleń",
            ownerName: "Nazwa właściciela",
            forestType: "Typ lasu",
            forestManager: "Leśniczy",
            specName: "Nazwa gatunku",
            specCode: "Kod gatunku",
            treeHeight: "Wysokość drzewa (m)",
            DBH: "Średnica DBH (cm)",
            avTreeVol: "Śr. wolumen drzewa (m3)",
            growStock: "Zapas drewna (m3)",
            growStockHa: "Zapas drewna (m3/ha)",
            specRepre: "Udział gatunku (%)",
            filter: "Filtr",
            default: "Domyślny",
            txMetric1: "1. Metryka",
            txMetric2: "2. Metryka",
            txType: "Typ",
            txAction: "Akcja",
            speciesAltitude: "Wysokość gatunkowa",
            woodStock: "Zapas drewna",
            story: "Warstwa",
            gray: 'Szary',
            green: 'Zielony',
            red: 'Czerwony',
            help: 'Pomoc',
            selectChannel: 'Wybierz kanał',
            selectBuyer: 'Wybierz kupującego',
            selectMill: 'Wybierz tartak',
            selectSupplier: 'Wybierz dostawcę',
            selectWoodType: 'Wybierz rodzaj drewna',
            selectLanguage: 'Wybierz język',
            selectConfiguration: 'Wybierz konfigurację',
            dateRange: "Zakres dat",
            spatialResolution: "Rozdzielczość przestrzenna:",
            cloudCoverage: "Zachmurzenie:",
            changeStrictness: "Próg:",
            resolution: "rozdzielczość",
            resamplingTo: "Resamplowanie do",
            method: "Metoda:",
            bands: "Pasma:",
            overlapPrct: "Nakładanie (%):",
            altImgIcon: "Ikona legendy",
            deviceType: "Typ urządzenia",
            allDevices: "Wszystkie urządzenia",
            bandComposite: "Kompozycja pasm"
        },
        message: {
            globalSearch: 'Szukaj',
            geoJsonCopied: 'GeoJSON skopiowany do schowka!',
            zoomToStory: 'Powiększ do warstwy',
            skysatHighResolution: 'Obrazowanie SkySat wysokiej rozdzielczości.',
            falseColorBands: 'Fałszywe kolory',
            changeDetection: 'Uwzględnij w detekcji zmian',
            switchGroup: 'Włącz/wyłącz całą grupę',
            deactiveSwiping: 'Wyłącz porównanie',
            swipeThisLayer: 'Porównaj tę warstwę',
            sentinelImages: 'Obrazy Sentinel.',
            changeDetectionTitle: 'Detekcja zmian w wybranym obszarze.',
            changeSegmentation: 'Segmentacja zmian',
            saveModification: 'Zapisz modyfikację',
            removeLastPoint: 'Usuń ostatni punkt',
            legendCannotBeDisplayed: 'Nie można wyświetlić legendy. Włącz co najmniej jedną warstwę z legendą.',
            couldNotFindCompartment: "Nie znaleziono żadnego wydzielenia leśnego w tym wyborze.",
            pleaseZoomIn: "Aby skorzystać z tej funkcji, powiększ mapę.",
            selectedPlanHasNoAttributes: "Wybrany plan nie ma atrybutów do wyświetlenia.",
            tooManyPolygons: "Za dużo zmian, proszę obniż próg detekcji zmian.",
            selectedGuidlinesHasNoAttributes: "Wybrane wskazówki gospodarcze nie mają atrybutów do pokazania.",
            pointVisibleOnTheMap: "Będzie widoczne przy punkcie na mapie.",
            noteDescription: "Opis notatki. Będzie widoczny po wybraniu.",
            labelLength: "Etykieta może mieć maksymalnie 50 znaków.",
            labelRequired: "Etykieta jest wymagana.",
            mightHaveGaps: "Dane mogą mieć luki z",
            tooManyOrLow: "Może wykryć zbyt dużo lub zbyt mało zmian",
            cloudCoverage: 'zachmurzenie',
            changeStrictness: "wartość progu",
            authenticationError: "Błąd uwierzytelniania - wyloguj się i zaloguj ponownie. Jeśli to nie pomoże, skontaktuj się z zespołem monitoringu lasów.",
            unauthorizedError: "Skontaktuj się z zespołem monitoringu lasów, aby uzyskać dostęp do aplikacji. Wygląda na to, że jesteś tutaj po raz pierwszy.",
            channelHasToBeSelected: "Musisz wybrać co najmniej jeden kanał.",
            buyerHasToBeSelected: "Musisz wybrać co najmniej jednego kupującego.",
            optionalFilter: "Opcjonalny filtr.",
            chooseInterval: "Wybierz przedział.",
            addGeographicNameOrParcelNumber: "Dodaj nazwę geograficzną lub numer działki.",
            searchFailed: "Wyszukiwanie nie powiodło się.",
            noResultsFound: "Brak wyników.",
            chooseDevice: "Wybierz typ urządzenia."
        },
        button: {
            line: 'Linia',
            area: 'Obszar',
            circle: 'Okrąg',
            new: 'Nowy',
            freehand: 'Rysowanie odręczne',
            submit: 'Zatwierdź',
            show: 'Pokaż',
            clear: 'Wyczyść',
            delete: 'Usuń',
            save: 'Zapisz',
            searchByPolygon: 'Poligon',
            searchByRectangle: 'Prostokąt',
            basedOnMapView: 'Widok mapy'
        },
        forestry: {
            age: 'Wiek',
            ps: 'Powierzchnia',
            density: 'Zagęszczenie',
            hs: 'Grupa gospodarcza',
            silviculturalOperations: 'Zabiegi hodowlane',
            harvestingOperations: 'Zabiegi zrębowe',
            businessMeeting: 'Spotkanie biznesowe',
            barkBeetle: 'Kornik',
            roadSideLocation: 'Lokalizacja przy drodze'
        },
        layers_list: {
            //groups
            background: 'Mapy podkładowe',
            satellite: 'Satelita',
            weather: 'Pogoda',
            business: 'Biznes',
            forestry: 'Leśnictwo',
            protected: 'Ochrona przyrody',
            protectedOther: 'Ochrona (inne)',
            //basemaps
            osm: 'OpenStreetMap',
            aerialPhotography: 'Zdjęcia lotnicze 2022/2023',
            aerialPhotography_2019_2020: 'Zdjęcia lotnicze 2019/2020',
            aerialPhotography_2017_2018: 'Zdjęcia lotnicze 2017/2018',
            planetMonth: 'PlanetScope miesięczny',
            buildingsNumber: 'Budynki z numerem',
            DMR5G: 'Cyfrowy model terenu 5G',
            slope: 'Nachylenie',
            more: 'więcej',
            aspect: 'Ekspozycja',
            north: 'Północ',
            northEast: 'Północny wschód',
            east: 'Wschód',
            southEast: 'Południowy wschód',
            south: 'Południe',
            southWest: 'Południowy zachód',
            west: 'Zachód',
            northWest: 'Północny zachód',
            hillshade: 'Cieniowanie terenu',
            topoMap: 'Mapa topograficzna',
            //forestry
            treeSpecies: 'Gatunki drzew',
            spruce: 'Świerk',
            beech: 'Buk',
            pine: 'Sosna',
            oak: 'Dąb',
            broadLeaved: 'Liściaste',
            kalwang1: 'Kalwang maks. zmiana 1.4.2024',
            kalwang2: 'Kalwang min. zmiana 1.4.2024',
            coniferous: 'Iglaste',
            mountainPine: 'Sosna górska',
            crop: 'Uprawa',
            logging: 'Wycinka',
            change: 'Zmiana',
            dronOrth20181120: 'Dron 20.11.2018',
            coniferousForest: 'Las iglasty',
            standConiferousForest: 'Stojący las iglasty',
            forestGrowthStages: 'Fazy wzrostu lasu',
            smallPoleStand: 'Młodnik',
            poleTimberStand: 'Drągowina',
            thicket: 'Podszyt',
            highForest: 'Drzewostan wysoki',
            barkBeetle: 'Kornik',
            deathTree: 'Martwe drzewo',
            reserve: 'Rezerwat',
            clearcut: 'Wycinka całkowita',
            area: 'Powierzchnia',
            //business
            compartmentsLHP: 'Podziały leśne LHP',
            fmGuidelines: 'Wytyczne gospodarki leśnej',
            fmPlans: 'Plany gospodarki leśnej',
            ageClass0: 'Klasa wieku 0',
            ageClass1: 'Klasa wieku 1 (1-20 lat)',
            ageClass2: 'Klasa wieku 2 (21-40 lat)',
            ageClass3: 'Klasa wieku 3 (41-60 lat)',
            ageClass4: 'Klasa wieku 4 (61-80 lat)',
            ageClass5: 'Klasa wieku 5 (81-100 lat)',
            ageClass6: 'Klasa wieku 6 (101-120 lat)',
            ageClass7: 'Klasa wieku 7 (121-140 lat)',
            ageClass8: 'Klasa wieku 8 (>140 lat)',
            oddeleniBoundary: 'Granica oddziału',
            dilecBoundary: 'Granica pododdziału',
            dilecBoundaryVariant: 'Granica pododdziału - wariant',
            compartContours: 'Granice wydzieleń',
            compartStand: 'Wydzielenia',
            compartStandLCR: 'Wydzielenia (LCR)',
            compartContoursLCR: 'Granice wydzieleń (LCR)',
            forestBorder: 'Granica lasu',
            border: 'Granica',
            ownership: 'Własność',
            lesyCR: 'Lasy Państwowe',
            stateForestVLS: 'Państwowe lasy VLS',
            stateForestStrSk: 'Państwowe lasy (szkoła)',
            stateForestMZPNP: 'Państwowe lasy MZP (PN)',
            stateForestMZPAOPK: 'Państwowe lasy MZP (AOPK)',
            stateForestOther: 'Państwowe lasy inne',
            formerStateForest: 'Byłe lasy państwowe',
            municipalUrbanForest: 'Lasy miejskie i gminne',
            ecclesiasticalForest: 'Lasy kościelne',
            legalEntity: 'Osoba prawna',
            individual: 'Osoba fizyczna',
            othersForest: 'Inne',
            businessAreas: 'Obszary biznesowe',
            zonePlana: 'Strefy - Planá',
            zoneZdirec: 'Strefy - Ždírec',
            zoneBrand: 'Strefy - Brand',
            zoneYbbs: 'Strefy - Ybbs',
            zoneBsLeonard: 'Strefy - B.S. Leonard',
            lessThan: 'Mniej niż 10 km',
            km10_20: '10 - 20 km',
            km20_40: '20 - 40 km',
            km40_60: '40 - 60 km',
            km60_80: '60 - 80 km',
            km80_100: '80 - 100 km',
            km100_120: '100 - 120 km',
            km120_140: '120 - 140 km',
            km140_160: '140 - 160 km',
            km160_180: '160 - 180 km',
            km180_200: '180 - 200 km',
            km200_220: '200 - 220 km',
            km220_240: '220 - 240 km',
            km240_260: '240 - 260 km',
            km260_280: '260 - 280 km',
            km280_300: '280 - 300 km',
            parcels: 'Działki',
            purchaseArea: 'Obszar zakupu',
            new: 'Nowy',
            loadingPlace: 'Miejsce załadunku',
            approxLocation: 'Przybliżona lokalizacja',
            suppliers: 'Dostawcy',
            delivery: 'Dostawa',
            notes: 'Notatki',
            //protected
            covenantProtectedArea: 'Obszar chroniony umową',
            protectedArea: 'Obszar chroniony',
            protectedTree: 'Drzewo chronione',
            stand: 'Wydzielenie',
            wetland: 'Tereny podmokłe',
            //Small protected area
            smallProtectedArea: "Mały obszar chroniony",
            smallProtectedAreaPA: "Mały obszar chroniony (strefa ochronna)",
            nationalNaturReser: 'Rezerwat przyrody krajowy',
            nationalNaturMonum: 'Pomnik przyrody krajowy',
            natureReservation: 'Rezerwat przyrody',
            naturalMonument: 'Pomnik przyrody',
            declarProtZone: 'Wyznaczona strefa ochronna',
            protZoneLaw: 'Strefa ochronna ustawowa',
            //Memorial trees
            memorialTrees: 'Drzewo pomnikowe',
            memorialTreesLine: 'Drzewo pomnikowe - linia',
            memorialTreesLineParticular: 'Drzewa pomnikowe bez lokalizacji - linia',
            memorialTreesArea: 'Drzewo pomnikowe - obszar',
            solitaire: 'Soliterny',
            definitionPointAlley: 'Punkt definicyjny alei',
            alleyLocatedParticularTree: 'Aleja, drzewo indywidualne',
            memorialTreesAreaWithoutLocation: 'Drzewa pomnikowe bez lokalizacji - poligon',
            definitionPointGroup: 'Punkt definicyjny grupy',
            groupParticularTrees: 'Grupa, drzewo indywidualne',
            //Zoning NP arrondissement
            zoningArrondissement: 'Strefowanie PN - arrondissement',
            arrondissementLaw: "Obszar wg art. 18 ust. 3 ustawy nr 114/1992",
            //Quiet areas NP
            quietAreasNationalPark: "Strefy ciszy w parkach narodowych",
            quietArea: "Strefa ciszy",
            //Large protected area
            largeProtectedAreaZoning: 'Strefowanie dużych obszarów chronionych',
            largeProtectedArea: 'Duży obszar chroniony',
            borderCHKONP: 'Granica CHKO i PN',
            borderNPzoneA: 'PN - strefa A - naturalna',
            borderNPzoneB: 'PN - strefa B - blisko naturalna',
            borderNPzoneC: 'PN - strefa C - intensywna ochrona',
            borderNPzoneD: 'PN - strefa D - krajobraz kulturowy',
            borderCHKOII: 'CHKO - II strefa',
            borderCHKOIII: 'CHKO - III strefa',
            borderCHKOIV: 'CHKO - IV strefa',
            largeProtectedAreaOP: 'Duży obszar chroniony – strefy specjalne i ochronne',
            nationalParkNP: 'park narodowy (PN)',
            protectedAreaNP: 'obszar chronionego krajobrazu (CHKO)',
            protectionZones: 'strefy ochronne (OP)',
            //European important site
            europeanImportantSites: 'Europejskie obszary ważne (EVL)',
            europeanImportantSite: 'europejski obszar ważny',
            //Bird area
            birdAreas: 'Obszary ptasie (PO)',
            birdArea: 'obszar ptasi',
            //Biosferic reserve zoning
            biosphereReserveZoning: 'Strefowanie rezerwatu biosfery',
            zoneI: 'strefa I',
            zoneII: 'strefa II',
            zoneIII: 'strefa III',
            //Conceptual definition supraregional biocenters
            conceptualDefinitionSupraregionalBiocenters: 'USES – koncepcyjne wyznaczenie ponadregionalnych biocentrów',
            zone: 'strefa',
            //UNESCO World nature heritage
            worldNatureHeritageUNESCO: 'Światowe dziedzictwo przyrodnicze UNESCO',
            worldNatureHeritageSite: 'miejsce światowego dziedzictwa przyrody UNESCO',
            landscapeCareZoneAndSustainableDevelopment: 'strefa dbałości o krajobraz i zrównoważony rozwój',
            protectionZone: 'strefa ochronna',
            //Nationally important species
            nationallyImportantSpecies: "Miejsca występowania gatunków krajowo ważnych",
            //Geoparc
            geoparc: 'Geopark',
            geoparcUNESCO: 'Geopark UNESCO',
            nationalGeoparc: 'geopark krajowy',
            geoparcCandidate: 'kandydat na geopark',
            biotopeSpeciallyProtectedSpeciesLargeMammals: "Biotop gatunków szczególnie chronionych – duże ssaki",
            coreArea: "obszar rdzeniowy",
            migrationCoridor: "korytarz migracyjny",
            criticalZone: "strefa krytyczna",
            //Ramsar
            ramsarWetlands: "Obszary Ramsar",
            //at_plus
            orthophoto: 'Ortofotomapa',
            mapOverlay: 'Nakładka mapowa',
            digSurfMod: 'Cyfrowy model powierzchni',
            realEstates: 'Nieruchomości',
            dominantTreeSp: 'Dominujący gatunek drzewa',
            spruceTannedDouglFir: 'Świerk i jodła, daglezja',
            larch: 'Modrzew',
            spruceDouglasFir: 'Świerk, daglezja',
            stock: 'Zapas',
            natura2000: 'Natura2000',
            naturalMonPoint: 'Pomnik przyrody – punkt',
            naturalMonArea: 'Pomnik przyrody – obszar',
            smallProtArea: 'Mały obszar chroniony',
            forestPlan: 'Plan leśny',
            utilizFunction: 'Funkcja użytkowa',
            protectFunction: 'Funkcja ochronna',
            welfareFunction: 'Funkcja socjalna',
            objProtectFunction: 'Funkcja ochrony obiektu',
            objSiteProtectFunction: 'Funkcja ochrony obiektu/lokalizacji',
            withoutProtectFunction: 'Bez funkcji ochronnej',
            hazardZone: 'Strefa zagrożenia',
            moderateTorrentRisk: 'Umiarkowane ryzyko – potok',
            highTorrentRisk: 'Wysokie ryzyko – potok',
            moderateAvalancheRisk: 'Umiarkowane ryzyko – lawina',
            highAvalancheRisk: 'Wysokie ryzyko – lawina',
            reservationAreaBlue: 'Obszar osuwiskowy – niebieski',
            advisoryAreaBrown: 'Obszar ostrzegawczy – brązowy',
            advisoryAreaViolet: 'Obszar ostrzegawczy – fioletowy',
            //de_plus
            orthoDOP80: 'Cyfrowa ortofotomapa DOP80',
            orthoDOPCIR80: 'Cyfrowa ortofotomapa DOPCIR80',
            topoDTK500: 'Mapa topograficzna DTK500',
            webTopoKarte: 'Mapa topograficzna online',
            byLabel: 'Nakładka z etykietami',
            sent2RGB: 'Sentinel2 – RGB (2021)',
            sent2NIR: 'Sentinel2 – NIR (2021)',
            sent2NIRRER: 'Sentinel2 – NIRRER (2021)',
            domTreeDe: 'Dominujące gatunki drzew (2018)',
            forestMask: 'Maska lasu (2018)',
            fir: 'Jodła',
            douglasFir: 'Daglezja',
            alder: 'Olsza',
            birch: 'Brzoza',
            otherDecHigh: 'Inne liściaste – długowieczne',
            otherDecLow: 'Inne liściaste – krótkowieczne'
        },
        hint: {
            doneLabel: 'Gotowe',
            prevLabel: 'Wstecz',
            nextLabel: 'Dalej',
            title1: 'Witamy w monitoringu lasów',
            title2: 'Przełącznik warstw',
            title3: 'Legenda',
            title4: 'Wydzielenia leśne',
            title5: 'Nieruchomości',
            title6: 'Obrazy satelitarne',
            title7: 'Analityka leśna',
            title8: 'Notatki użytkownika',
            title9: 'Profil użytkownika',
            title10: 'Geolokalizacja',
            title11: 'Powiększanie mapy',
            title12: 'Ręczny pomiar',
            step1: 'Tutaj znajdziesz informacje o funkcjach i sterowaniu.',
            step2: 'Tutaj możesz aktywować lub dezaktywować konkretne warstwy mapy, np. pokrycie leśne, granice działek itd.',
            step3: 'Tutaj możesz zobaczyć legendę dla aktywnych warstw. Legendy są zależne od wybranej warstwy, np. przy aktywnej warstwie lasu wyświetla się jej legenda.',
            step4: 'Narzędzie Pokrycie leśne pozwala wyświetlić szczegółowe informacje o pokryciu. Obszar zainteresowania można zaznaczyć kilkoma narzędziami: rysowaniem ręcznym, poligonem lub wskaźnikiem punktu.',
            step5: 'Narzędzie Nieruchomości pozwala wyświetlić szczegółowe informacje o nieruchomościach. Obszar zainteresowania można zaznaczyć rysując ręcznie, poligonem lub wskaźnikiem punktu.',
            step6: 'To narzędzie pozwala aktywować/dezaktywować obrazy satelitarne dla konkretnego obszaru.',
            step7: 'Narzędzie Analityka leśna pozwala wyświetlić szczegółowe dane leśne, np. liczbę gatunków drzew, ich średni wiek itd. Wszystko zależnie od wysokości. Obszar możesz wyznaczyć rysując ręcznie lub poligonem.',
            step8: 'To narzędzie pozwala dodać własną notatkę bezpośrednio na mapę.',
            step9: 'W tej sekcji znajdziesz informacje o swoim koncie użytkownika.',
            step10: 'Kliknij ten przycisk, aby pokazać swoją fizyczną lokalizację na mapie.',
            step11: 'Ta grupa przycisków służy do powiększania i pomniejszania mapy. Można też używać kółka myszy lub gestów na ekranie dotykowym.',
            step12: 'To narzędzie pozwala wyznaczyć powierzchnię na mapie. Możesz użyć poligonu, okręgu lub linii.'
        }
    }
}

export default translation;